module.exports = Em.Mixin.create
  beforeModelAuth: Em.K

  session: Em.inject.service()

  beforeModel: (transition) ->
    if @get('session.loggedIn')
      @beforeModelAuth(transition)
    else
      @get('session').set('lastTransition', transition)
      @transitionTo 'auth.login'


